<template>
    <form class="registration" v-bind:action="apiUrl + '/register'" v-on:submit.prevent="handleSubmit">
        <h3 class="has-margin-b30">{{ __('Sign Up') }}</h3>

        <div class="form__group" v-bind:class="{ 'has-error' : errors.name }">
            <label class="form__label" for="name">{{ __('Full name') }}</label>
            <input class="form__control is-large dark-color" id="name" type="text" autocomplete="off"
                   v-bind:placeholder="__('Enter name')"
                   v-model="name"
            />
            <small class="form__error_nm" v-if="errors.name">{{ errors.name[0] }}</small>
        </div>
        <div class="form__group" v-bind:class="{ 'has-error' : errors.email }">
            <label class="form__label" for="email">{{ __('Email') }}</label>
            <input class="form__control is-large dark-color" id="email" type="email" autocomplete="off"
                   v-bind:placeholder="__('Enter email')"
                   v-model="email"
                   v-on:blur="checkEmail"
                   v-on:keyup="resetError"
            />
            <small class="form__error_nm" v-if="errors.email">{{ errors.email[0] }}</small>
        </div>
        <div class="form__group" v-bind:class="{ 'has-error' : errors.password }">
            <label class="form__label" for="password">{{ __('Password') }}</label>
            <input class="form__control is-large dark-color" id="password" type="password" autocomplete="off"
                   v-bind:placeholder="__('Password')"
                   v-model="password"
                    />
            <small class="form__error_nm" v-if="errors.password">{{ errors.password[0] }}</small>
        </div>
        <div class="form__group">
            <label class="form__label" for="password-confirm">{{ __('Confirm password') }}</label>
            <input class="form__control is-large dark-color" id="password-confirm" type="password" autocomplete="off"
                   v-bind:placeholder="__('Confirm password')"
                   v-model="confirmPassword"
                    />
        </div>

        <button class="btn is-primary edit-profile__save-btn" type="submit">{{ __('Sign Up') }}</button>


        <span class="view__separator dark-color"><span>{{ __('or') }}</span></span>

        <a class="btn btn--facebook-login" v-on:click="handleSocialLogin('facebook')">
            <span class="jam jam-facebook is-circle"></span>
            {{ __('Sign up with Facebook') }}
        </a>
        <a class="btn btn--google-login" v-on:click="handleSocialLogin('google')">
            <span class="jam jam-google"></span>
            {{ __('Sign up with Google') }}
        </a>
    </form>
</template>

<script>
    import { eventBus } from '../eventBus.js';

    export default {
        computed: {
            imageStyleProperty: function () {
                let prop = '';

                let height = this.imageObj.height;
                let width = this.imageObj.width;
                let scale = this.imageObj.scale;

                if (this.imageObj.height != 0 && this.imageObj.width != 0) {
                    if (this.imageObj.initialHeight && this.imageObj.initialWidth) {
                        prop += 'height: ' + (height * scale) + 'px; ';
                        prop += 'width: ' + (width * scale) + 'px; ';
                    }

                    prop += 'transform: translate(' + this.imageObj.currentX + 'px, ' + this.imageObj.currentY + 'px);';
                } else {
                    prop = 'transform: translate(0px, 0px);';
                }

                return prop.trim();
            }
        },
        data: function () {
            return {
                confirmPassword: '',
                email: '',
                errors: {},
                imageObj: {
                    currentX: 0,
                    currentY: 0,
                    height: 0,
                    initialHeight: 0,
                    initialWidth: 0,
                    initialX: 0,
                    initialY: 0,
                    isLoaded: false,
                    isMoving: false,
                    offsetX: 0,
                    offsetY: 0,
                    scale: 1,
                    scaleMin: 1,
                    scaleMax: 1,
                    src: null,
                    width: 0
                },
                imgHeight: 200,
                imgWidth: 200,
                name: '',
                password: '',
                showScaleImageControl: false
            }
        },
        methods: {
            centerImage: function () {
                this.imageObj.currentX = Math.floor((200 - this.imageObj.width * this.imageObj.scale) / 2);
                this.imageObj.currentY = Math.floor((200 - this.imageObj.height * this.imageObj.scale) / 2);

                this.imageObj.offsetX = this.imageObj.currentX;
                this.imageObj.offsetY = this.imageObj.currentY;
            },
            checkEmail: function () {
                this.errors = {};
                this.$http.get(this.apiUrl + '/users/check/' + this.email).then(function (response) {
                    if (response.body) {
                        this.errors = { email: ['The email has already been taken.'] };
                    }
                }.bind(this));
            },
            handleImageDrag: function (e) {
                if (this.imageObj.isMoving) {
                    e.preventDefault();

                    if (e.type === "touchmove") {
                        this.imageObj.currentX = e.touches[0].clientX - this.imageObj.initialX;
                        this.imageObj.currentY = e.touches[0].clientY - this.imageObj.initialY;
                    } else {
                        this.imageObj.currentX = e.clientX - this.imageObj.initialX;
                        this.imageObj.currentY = e.clientY - this.imageObj.initialY;
                    }

                    if (this.imageObj.width * this.imageObj.scale >= this.imgWidth) {
                        if (this.imageObj.currentX < 0 && this.imageObj.currentX < -1 * this.imageObj.width * this.imageObj.scale + this.imgWidth) {
                            this.imageObj.currentX = -1 * this.imageObj.width * this.imageObj.scale + this.imgWidth;
                        } else if (this.imageObj.currentX > 0) {
                            this.imageObj.currentX = 0;
                        }
                    } else {
                        if (this.imageObj.currentX > 0 && this.imageObj.currentX > this.imgWidth - this.imageObj.width * this.imageObj.scale) {
                            this.imageObj.currentX = this.imgWidth - this.imageObj.width * this.imageObj.scale;
                        } else if (this.imageObj.currentX < 0) {
                            this.imageObj.currentX = 0;
                        }

                    }

                    if (this.imageObj.height * this.imageObj.scale >= this.imgHeight) {
                        if (this.imageObj.currentY < 0 && this.imageObj.currentY < -1 * this.imageObj.height * this.imageObj.scale + this.imgHeight) {
                            this.imageObj.currentY = -1 * this.imageObj.height * this.imageObj.scale + this.imgHeight;
                        } else if (this.imageObj.currentY > 0) {
                            this.imageObj.currentY = 0;
                        }
                    } else {
                        if (this.imageObj.currentY > 0 && this.imageObj.currentY > this.imgHeight - this.imageObj.height * this.imageObj.scale) {
                            this.imageObj.currentY = this.imgHeight - this.imageObj.height * this.imageObj.scale;
                        } else if (this.imageObj.currentY < 0) {
                            this.imageObj.currentY = 0;
                        }

                    }

                    this.imageObj.offsetX = this.imageObj.currentX;
                    this.imageObj.offsetY = this.imageObj.currentY;
                }
            },
            handleImageDragEnd: function (e) {
                e.preventDefault();

                this.imageObj.initialX = this.imageObj.currentX;
                this.imageObj.initialY = this.imageObj.currentY;

                this.imageObj.isMoving = false;
            },
            handleImageDragStart: function (e) {
                e.preventDefault();

                if (e.type === "touchstart") {
                    this.imageObj.initialX = e.touches[0].clientX - this.imageObj.offsetX;
                    this.imageObj.initialY = e.touches[0].clientY - this.imageObj.offsetY;
                } else {
                    this.imageObj.initialX = e.clientX - this.imageObj.offsetX;
                    this.imageObj.initialY = e.clientY - this.imageObj.offsetY;
                }

                if (e.target === document.querySelector('.edit-profile__edit-photo__photo-preview')) {
                    this.imageObj.isMoving = true;
                }
            },
            handleImageScale: function () {
                this.imageObj.currentX = 0;
                this.imageObj.currentY = 0;

                this.imageObj.offsetX = this.imageObj.currentX;
                this.imageObj.offsetY = this.imageObj.currentY;
            },
            handleImageUpload: function () {
                const file = document.querySelector('.edit-profile__image-control').files[0];
                const img = new Image();
                const reader = new FileReader();

                reader.readAsDataURL(file);
                reader.onload = function () {
                    this.imageObj.src = reader.result;
                    this.imageObj.scale = 1;
                    img.src = reader.result;

                }.bind(this);

                img.onload = function () {

                    const imgEl = document.querySelector('.edit-profile__edit-photo__photo');

                    this.imageObj.initialHeight = imgEl.offsetHeight;
                    this.imageObj.initialWidth = imgEl.offsetWidth;

                    this.imageObj.isLoaded = true;

                    this.imageObj.height = Math.floor(this.imageObj.initialHeight * this.imageObj.scale);
                    this.imageObj.width = Math.floor(this.imageObj.initialWidth * this.imageObj.scale);

                    let scale = 1;
                    if (this.imgWidth > this.imageObj.width) {
                        scale = this.imgWidth / this.imageObj.width;
                    }
                    if (this.imgHeight > this.imageObj.height) {
                        scale = this.imgHeight / this.imageObj.height;
                    }
                    this.imageObj.height = this.imageObj.height * scale;
                    this.imageObj.width = this.imageObj.width * scale;

                    this.showScaleImageControl = true;

                    if (this.imageObj.width < img.width) {
                        this.imageObj.scaleMin = 0.5;
                        this.imageObj.scaleMax = Math.floor(img.width / this.imageObj.width);
                    } else {
                        this.imageObj.scaleMin = Math.floor(this.imageObj.width / img.width);
                        this.imageObj.scaleMax = 0.5;
                    }
                }.bind(this);
            },
            handleSocialLogin: function (provider) {
                eventBus.$emit('show-loader');

                this.$http.get(this.apiUrl + '/login/social/' + provider).then(function (response) {
                    window.location.replace(response.body.url);
                }, function (response) {
                    eventBus.$emit(
                            'show-alert',
                            'error',
                            this.__('There was an error retrieving data from the server.')
                    );

                    eventBus.$emit('hide-loader');
                });
            },
            handleSubmit: function (e) {
                eventBus.$emit('show-loader');

                const form = e.target;
                const action = form.getAttribute('action');

                this.$http.post(action, {
                    email: this.email,
                    image: this.imageObj,
                    name: this.name,
                    password: this.password,
                    password_confirmation: this.confirmPassword,
                    startdesk: this.activeStartdesk ? this.activeStartdesk.slug : null
                }).then(function (response) {
                    //eventBus.$emit('show-alert', 'success', this.__('Registration successful. A verification link has been sent to your email account. '));
                    eventBus.$emit('show-alert', 'success', this.__('Registration successful.'));
                    eventBus.$emit('hide-loader');
                    
                    this.$http.post(action.replace('/register', '/login'), {
                        email: this.email,
                        password: this.password
                    }).then(function (response) {
                        this.loginUser(response.body);

                        eventBus.$emit('hide-loader');
                    }, function (response) {
                        if (response.status == 422 && response.body.errors) {
                            this.errors = response.body.errors;
                        }

                        if (response.status == 429 && response.body.errors) {
                            this.errors = response.body.errors;

                            eventBus.$emit(
                                    'show-alert',
                                    'error',
                                    response.body.errors.email[0]
                            );
                        }

                        eventBus.$emit('hide-loader');
                    });
                    /*
                    this.$router.push({
                        name: 'startdesks.view',
                        params: { startdesk: this.activeStartdesk.slug, u: this.activeStartdesk.is_user_startdesk }
                    });
                    */
                }, function (response) {
                    if (response.status == 422 && response.body.errors) {
                        this.errors = response.body.errors;
                    }

                    eventBus.$emit(
                        'show-alert',
                        'error',
                        this.__('There were some errors validation the form. Please review and correct them.')
                    );
                    eventBus.$emit('hide-loader');
                });
            },
            removeImage: function () {
                this.imageObj = {
                    currentX: 0,
                    currentY: 0,
                    height: 0,
                    initialX: 0,
                    initialY: 0,
                    isLoaded: false,
                    isMoving: false,
                    offsetX: 0,
                    offsetY: 0,
                    scale: 1,
                    tile__name: 1,
                    scaleMax: 1,
                    src: null,
                    width: 0
                };

                this.showScaleImageControl = false;
            },
            resetError: function () {
                this.errors = {};
            },
            showImageUploadDialog: function () {
                document.querySelector('.edit-profile__image-control').click();
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/RegisterSidebar.vue